module.exports = __webpack_public_path__ + "doubt.c40ed695.png";